import { Controller } from '@hotwired/stimulus'
import { changeProductSelection } from '../selection/product-selection-api'

export default class extends Controller {
  static classes = ['selected', 'unselected']
  static values = {
    style: String
  }

  connect() {
    // Set initial selected state based on class
    if (this.element.classList.contains('selected')) {
      this.markAsSelected()
    }
  }

  select(event) {
    event?.preventDefault()
    
    const stateElement = document.getElementById('product-selection-state')
    if (!stateElement) {
      console.error('Product selection state element not found')
      return
    }

    // Let the API handle the selection change
    changeProductSelection(this.element, stateElement)
  }

  markAsSelected() {
    this.element.classList.remove('unselected')
    this.element.classList.add('selected')
  }

  markAsUnselected() {
    this.element.classList.remove('selected')
    this.element.classList.add('unselected')
  }

  // Called when selection state changes from outside
  updateSelection(selectedStyle) {
    if (this.styleValue === selectedStyle) {
      this.markAsSelected()
    } else {
      this.markAsUnselected()
    }
  }
}
